export default {
  'investment.title': 'Portefeuille d\'investissement stratégique',
  'investment.subtitle': 'Nous investissons activement et acquérons des entreprises technologiques à fort potentiel pour accélérer l\'innovation et créer de la valeur dans l\'écosystème technologique.',
  'investment.description': 'Notre stratégie d\'investissement se concentre sur l\'identification et l\'accompagnement d\'entreprises qui s\'alignent avec notre vision de transformer le paysage de la technologie financière.',
  
  'investment.features': [
    'Financement et accélération de startups',
    'Services de conseil en fusions-acquisitions',
    'Gestion de portefeuille',
    'Développement de stratégie de croissance'
  ],
  
  'investment.fintech.title': 'Startups Fintech',
  'investment.fintech.description': 'Entreprises de technologie financière à fort potentiel révolutionnant les paiements numériques, le prêt et les services financiers.',
  'investment.fintech.portfolio': '8 Entreprises',
  'investment.fintech.growth': '+45%',
  
  'investment.realEstate.title': 'Technologie Immobilière',
  'investment.realEstate.description': 'Participations stratégiques dans la technologie immobilière et les projets de développement immobilier avec un fort potentiel de croissance.',
  'investment.realEstate.portfolio': '5 Projets',
  'investment.realEstate.growth': '+32%',
  
  'investment.agribusiness.title': 'Agroalimentaire',
  'investment.agribusiness.description': 'Investissements diversifiés dans la technologie agricole et les solutions d\'agriculture durable pour la sécurité alimentaire.',
  'investment.agribusiness.portfolio': '3 Entreprises',
  'investment.agribusiness.growth': '+28%',
  
  'investment.portfolio': 'Portefeuille',
  'investment.growth': 'Croissance',
};
